import apiClient from './apiClient';

export async function submitSupportTicket(ticketData, user) {
  const payload = {
    subject: `[${ticketData.type}] ${ticketData.subject}`,
    description: ticketData.description,
    email: user.email,
    name: user.name || user.displayName || user.email,
    user_uuid: user.uuid,
  };
  return apiClient.post('zendesk/tickets', payload);
}

export async function getTicketStatus(ticket_id) {
  return apiClient.get(`zendesk/tickets/${ticket_id}`);
}

export async function getUserTickets(user_uid) {
  return apiClient.get(`zendesk/users/${user_uid}/tickets`);
}